import cn from "classnames";
import { useTranslation } from "react-i18next";

import { ESupportTicketPriority } from "../../aiTickets.types";

import styles from "./PriorityPill.module.scss";

interface Props {
  priority: ESupportTicketPriority;
  withChevron?: boolean;
}

const Chevron = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path
      d="M3 4.5L6 7.5L9 4.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const LABEL: Record<ESupportTicketPriority, string> = {
  [ESupportTicketPriority.Urgent]: "Urgent",
  [ESupportTicketPriority.Alert]: "Alert",
  [ESupportTicketPriority.Reminder]: "Reminder",
  [ESupportTicketPriority.FollowUp]: "Follow up",
  [ESupportTicketPriority.Low]: "Information",
};

const CLASS: Record<ESupportTicketPriority, string> = {
  [ESupportTicketPriority.Urgent]: styles.urgent,
  [ESupportTicketPriority.Alert]: styles.alert,
  [ESupportTicketPriority.Reminder]: styles.reminder,
  [ESupportTicketPriority.FollowUp]: styles.followUp,
  [ESupportTicketPriority.Low]: styles.information,
};

const PriorityPill = ({ priority, withChevron = true }: Props) => {
  const { t } = useTranslation();
  return (
    <span className={cn(styles.pill, CLASS[priority])}>
      {t(LABEL[priority])}
      {withChevron && <Chevron />}
    </span>
  );
};

export default PriorityPill;
